import axios from "../axios";

class TenderClassService {
    getListIdNameAll() {
        return axios.get("tender-class?perPage=1000&fields[tender_class]=id,slug,name");
    }
}

export default new TenderClassService();
